import { updateParameterUseCase } from '@src/main/modules/parameters/application/update/update-parameter.usecase';
import { UpdateParameterRequest } from '@src/main/modules/parameters/infrastructure/dto/updateParameterRequest';
import { createParameterHttpRepository } from '@src/main/modules/parameters/infrastructure/repository/ParameterHttpRepository';
import { useAuth } from '@src/main/shared/context/AuthContext';
import { useMutation } from '@tanstack/react-query';
import { useCallback, useMemo } from 'react';

export const useUpdateParameter = () => {
  const { user } = useAuth();

  const getToken = useCallback(async () => user?.token ?? '', [user?.token]);
  const tokenProvider = useMemo(() => ({ getToken }), [getToken]);

  const repository = useMemo(() => {
    if (!user?.token) return null;
    return createParameterHttpRepository(tokenProvider);
  }, [user?.token, tokenProvider]);

  return useMutation({
    mutationFn: async ({ id, data }: { id: string; data: UpdateParameterRequest }) => {
      if (!repository) throw new Error('Repository not initialized');
      return await updateParameterUseCase(id, data, tokenProvider);
    },
  });
};
